export const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.userAgent);
/** Modifier label for ⌘/Ctrl shortcuts. */
export const MOD = IS_MAC ? '⌘' : 'Ctrl';

export interface ShortcutDef {
  keys: string[];
  /** i18n key of the description. */
  label: string;
}

/**
 * Every global shortcut, grouped for the `?` overlay. ⌘Space belongs to the OS (Spotlight), so the
 * launcher uses ⌘K / Ctrl+K and `/`.
 */
export const SHORTCUT_GROUPS: { title: string; items: ShortcutDef[] }[] = [
  {
    title: 'shortcuts.general',
    items: [
      { keys: [`${MOD} K`], label: 'shortcuts.launcher' },
      { keys: ['/'], label: 'shortcuts.launcherSlash' },
      { keys: [`${MOD} J`], label: 'shortcuts.ask' },
      { keys: ['?'], label: 'shortcuts.help' },
      { keys: ['['], label: 'shortcuts.sidebar' },
      { keys: [']'], label: 'shortcuts.panel' },
    ],
  },
  {
    title: 'shortcuts.inLauncher',
    items: [
      { keys: ['↑', '↓'], label: 'shortcuts.move' },
      { keys: ['⏎'], label: 'shortcuts.open' },
      { keys: [`${MOD} ⏎`], label: 'shortcuts.secondary' },
      { keys: ['Tab'], label: 'shortcuts.drill' },
      { keys: ['>'], label: 'shortcuts.commandMode' },
      { keys: ['@'], label: 'shortcuts.mention' },
      { keys: ['Esc'], label: 'shortcuts.back' },
    ],
  },
  {
    title: 'shortcuts.panes',
    items: [
      { keys: ['Esc'], label: 'shortcuts.interrupt' },
      { keys: ['⇧ Tab'], label: 'shortcuts.modeLine' },
    ],
  },
];

/** Extra `g <key>` destinations beyond the main NAV (guided setup). */
export const EXTRA_GO: { hotkey: string; to: string; search?: Record<string, string>; label: string }[] = [
  { hotkey: 'i', to: '/onboarding', label: 'onboarding.title' },
];
